import { BRAND_DOMAIN, BRAND_NAME } from "@/constants/Brand";
import Facebook from "@/assets/icons/facebook.svg?react";
import instagram from "@/assets/icons/instagram.svg?react";
import tiktok from "@/assets/icons/tiktok.svg?react";
import claimsImg from "@/assets/claims.2f94455a.png";
import { Link } from "react-router-dom";
import { ComponentType, SVGProps } from "react";

type SocialLink = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  href: string;
  label: string;
};

const Footer = () => {
  const footerSections = [
    {
      title: "Sobre nosotros",
      links: [
        { label: "Inicio", href: "/" },
        {
          label: "Acerca de PasajesBaratos",
          href: "https://costamar.com.pe/quienes-somos",
          external: true
        },
        {
          label: "Centro de ayuda",
          href: "https://costamar.com.pe/preguntas-frecuentes",
          external: true
        },
      ],
    },
    {
      title: "Información legal",
      links: [
        {
          label: "Políticas de privacidad y seguridad",
          href: "https://legal.costamar.com.pe/politica-privacidad",
          external: true
        },
        {
          label: "Términos y condiciones generales",
          href: "https://www.costamar.com.pe/es/costamar-travel-peru/terminos-y-condiciones",
          external: true
        },
        {
          label: "Política sobre cookies",
          href: "https://www.costamar.com.pe/es/costamar-travel-peru/politicas-de-uso-de-cookies",
          external: true
        },
      ],
      image: claimsImg,
    },
  ];

  const socialLinks: SocialLink[] = [
    { icon: Facebook, href: "https://www.facebook.com/PasajesBaratos.latam", label: "Facebook" },
    { icon: instagram, href: "https://www.instagram.com/pasajesbaratos?igsh=MXRxbng2Mms1N3p6bQ==", label: "Instagram" },
    { icon: tiktok, href: "https://www.tiktok.com/@pasajesbaratos", label: "TikTok" },
  ];

  return (
    <footer className="bg-background border-t border-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          <div>
            <h3 className="font-bold text-primary mb-4">{BRAND_NAME}</h3>
            <p className="space-y-2 text-sm text-muted-foreground">
              Con el respaldo del Grupo Costamar<br/>
              Costamar Travel Cruise & Tours S.A.C.<br/>
              RUC: 20126339632
            </p>
          </div>
          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="font-bold text-primary mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                  {link.external ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-muted-foreground hover:text-secondary transition-colors"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      className="text-sm text-muted-foreground hover:text-secondary transition-colors"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
                ))}
              </ul>
              {section.image && (
                <a href="https://legal.costamar.com.pe/libro-reclamaciones" target="_blank">
                  <img src={section.image} alt="Libro de reclamaciones" className="mt-5" width={125} height={73.29} />
                </a>
              )}
            </div>
          ))}

          <div>
            <h3 className="font-bold text-primary mb-4">Síguenos en nuestras redes sociales</h3>
            <div className="flex gap-2 mb-6">
              {socialLinks.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  target="_blank"
                  className="w-9 h-9 rounded-full bg-muted flex items-center justify-center hover:bg-secondary hover:text-secondary-foreground transition-colors"
                >
                   <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-primary text-primary-foreground py-4">
        <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
           <img src="logo_horizontal.svg" alt={BRAND_DOMAIN} width={168.67} height={40}></img>
          </div>
          <p className="text-xs text-primary-foreground/70">
            © 2026 { BRAND_NAME}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
